import React, { useState, useEffect } from "react";

import Form from "react-bootstrap/Form";

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"



const AttendeeGroup = (props) => {

    const [group, setGroup] = useState(props.attendee.group)

    function changeGroup(value){

        setGroup(value)
        if(Number.isInteger(parseInt(value))){
            const body = {
                group: value,
                auth0sub: props.attendee.auth0sub,
                eventid: props.eventid
            }
            apiPost(`intranetevents/changegroup`, body).then(result => {
                console.log(result)
            })
        }
    }

    return (
        <>
            <Form.Control onChange={(event) => changeGroup(event.target.value)} type="text" value={group} />
        </>
    )
}

export default AttendeeGroup;